import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import Save from "../../../Assets/img/svg/save.svg";
import Cancel from "../../../Assets/img/svg/cancel.svg";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../../../Assets/jss/customStyle";
import $ from "jquery";
import List from "@material-ui/core/List";
import { Multiselect } from "multiselect-react-dropdown";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Delete from "../../../Assets/img/svg/delete.svg";
import axios from "axios";
import API from "../../../helpers/endpointService";
import del from "../../../Assets/img/svg/Del.svg";
import Active from "../../../Assets/img/svg/active.svg";
import Deactive from "../../../Assets/img/svg/deactive.svg";
import { isUserRole } from "../../Constants.js";
import {warningAlert} from "../../custom/alert"

class AddEditExternalClientShips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      menu: true,
      isEdit: false,
      EmptyNameError: false,
      cancel: false,
      ShipIds: [],
      ShipsNameList: [],
      ShipsList: [],
    };
  }

  componentDidMount() {
    window.location.pathname === "/activesampleships/add"
      ? (this.state.isEdit = false)
      : (this.state.isEdit = true);
    this.setState({});
    this.getShipList();
    if (this.state.isEdit == true) {
      this.getShipinfo(localStorage.getItem("EditUser"));
    }
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
  }
  getShipList = (data) => {
   let apiUrl=API.GET_EXTERNAL_CLIENT_SHIPS; 
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data?.length > 0) {
            this.state.ShipsList = response.data;
            this.setState({});
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
  getShipinfo = (data) => {
    let apiUrl = API.GET_EXTERNAL_CLIENT;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data?.length > 0) {
            this.state.ShipsNameList = response.data;
            this.setState({});
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    $("#ESHIP1 .MuiListItemText-primary").addClass("spanTopBar")
    $("#ExterMngt1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#ExterMngt11").addClass("d-none");
    $("#ExterMngt11").removeClass("d-block");
  }

  sidebar = () => {
    if (this.state.cancel === true) {
      window.$("#cancelpopup1").modal("show");
    } else {
      this.props.navigate("/SidebarUser");
    }
  };
  SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup1").modal("hide");
    this.props.navigate("/SidebarUser");
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
    $("#ESHIP1 .MuiListItemText-primary").addClass("spanTopBar")
    $("#ExterMngt1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#ExterMngt11").removeClass("d-none");
    $("#ExterMngt11").addClass("d-block");
    $("#ECPAT .MuiListItemText-primary").addClass("fw-bolder")
    $("#ECPA").addClass("active-color")
  };
  Save = () => {
    if (this.state.addData === "") {
      this.state.EmptyNameError = true;
      this.setState({});
    } else {
      this.state.EmptyNameError = false;
      this.setState({});
    }
    if (this.state.EmptyNameError === false) {
      this.props.dispatch({ type: "CANCEL", data: false });
      if (this.state.isEdit == false) {
        this.addeditshipinfo();
      } else {
        this.addeditshipinfo();
      }
    }
  };
  onSelectChange = (item) => {
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.cancel = true;
    this.state.ShipIds = [];
    this.state.ShipsNameList = item;
    if (item && item.length > 0) {
      item.map((val, index) => {
        this.state.ShipIds.push(val.ShipId);
      });
    }
    this.setState({}, () => {
      console.log(this.state.ShipIds);
    });
  };
  onRemoveChange(item) {
    this.state.ShipIds = [];
    this.state.ShipsNameList = item;
    if (item && item.length > 0) {
      item.map((val, index) => {
        this.state.ShipIds.push(val.ShipId);
      });
    }
    this.setState({}, () => {
      console.log(this.state.ShipIds);
    });
  }

  addeditshipinfo = () => {
    if(this.state.isEdit===true && this.state.ShipIds.length ===0){
      if (this.state.ShipsNameList && this.state.ShipsNameList.length > 0) {
        this.state.ShipsNameList.map((val, index) => {
          this.state.ShipIds.push(val.ShipId);
        });
        this.setState({}, () => {
          console.log(this.state.ShipIds);
        });
    }
    }
    let apiUrl = API.POST_EXTERNAL_CLIENT;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.ShipIds,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.props.navigate(`/activesampleships`);
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  AddCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup").modal("hide");
    this.props.navigate(`/activesampleships`);
  };

  AddCancel1 = () => {
    if (this.state.cancel == true) {
      window.$("#cancelpopup").modal("show");
    } else {
      this.props.dispatch({ type: "CANCEL", data: false });

      this.props.navigate(`/activesampleships`);
    }
  };

  render() {
    const { isEdit } = this.state;
    let { classes, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4 mob-topfixed ">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={() => this.sidebar()}>
                    <ListItemText
                      id={"ESHIP" + 1}
                      className="  textNaviIcon"
                      primary="Sample Ships"
                    />
                    <NavigateNextIcon
                      id="ESHIP"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                {this.state.isEdit ? (
                  <h4 className="col-12">Edit Active Sample Ships</h4>
                ) : (
                  <h4 className="col-12">Add  Active Sample Ships</h4>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      class="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td className="border-right text-center">
                    <button
                      className={`${classes.button}`}
                      onClick={() => {
                        this.Save();
                      }}
                    >
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                  </td>
                  <td className="border-right text-center">
                    <button
                      className={`${classes.button} `}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <table className="dataTable" width="100%">
                <tbody>
                  <tr>
                    <td width="5%" className="border-right text-center">
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.AddCancel1}
                      ></i>
                    </td>
                    <td className="" width="95%">
                      <button
                        className={`${classes.button}`}
                        onClick={() => {
                          this.Save();
                        }}
                      >
                        <img src={Save} style={{ marginTop: "-4px" }}></img>
                        &nbsp;Save
                      </button>
                      <button
                        className={`${classes.button} pl-3`}
                        onClick={this.AddCancel1}
                      >
                        <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                        &nbsp;Cancel
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <div className="mt-130" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
            {this.state.isMobile ? (
              <></>
            ) : this.state.isEdit ? (
              <h6 className="col-12 mx-2 pt-2 ml-1">
                Edit Active Sample Ships
              </h6>
            ) : (
              <h6 className="col-12 mx-2 pt-2 ml-1">
                Add Active Sample Ships
              </h6>
            )}
            <div
              className={
                this.state.isMobile
                  ? "row mt-1 mx-0 pr-2 pt-1"
                  : "row mt-1 mx-3 pr-2 pt-1"
              }
            >
              <div
                className={`row mt-2 mx-1 align-items-center ${
                  this.state.isMobile ? "" : "text-row"
                }`}
              >
                <div
                  className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${
                    this.state.isMobile
                      ? "border-left border-right border-top col-md-12"
                      : "col-md-2 px-0"
                  }`}
                >
                  <label
                    className={
                      this.state.isMobile
                        ? "d-flex pt-2"
                        : "float-end d-flex text-right"
                    }
                  >
                    Ship Name&nbsp;:
                    <div className={`${classes.helperText}`}>
                      <div className="MuiFormHelperText-contained">*</div>
                    </div>
                  </label>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${
                    this.state.isMobile
                      ? "border-left border-right border-bottom col-md-12 pt-1 pb-3"
                      : "col-md-4 pt-4 pb-4"
                  }`}
                >
                  {this.state.EmptyNameError ? (
                    <>
                      <Multiselect
                        options={this.state.ShipsList ?? []}
                        showArrow={false}
                        displayValue="ShipName"
                        isObject={true}
                        style={{
                          option: {
                            marginRight: 0,
                            display: "block",
                            fontWeight: "normal",
                          },
                          chips: { "background-color": "rgb(3, 121, 132)" },
                        }}
                        onSelect={(item) => this.onSelectChange(item)}
                        onRemove={(item) => this.onRemoveChange(item)}
                        selectedValues={this.state.ShipsNameList}
                        className="border-radius"
                        placeholder={
                          this.state.ShipsNameList &&
                          this.state.ShipsNameList.length
                            ? ""
                            : "Select"
                        }
                        closeIcon="cancel"
                        value={this.state.ShipsNameList}
                      />
                    </>
                  ) : (
                    <>
                      <Multiselect
                        options={this.state.ShipsList ?? []}
                        displayValue="ShipName"
                        showArrow={true}
                        isObject={true}
                        style={{
                          option: {
                            marginRight: 0,
                            display: "block",
                            fontWeight: "normal",
                            zIndex: "5",
                          },
                          chips: { "background-color": "rgb(3, 121, 132)" },
                        }}
                        className="border-radius"
                        onSelect={(item) => this.onSelectChange(item)}
                        onRemove={(item) => this.onRemoveChange(item)}
                        selectedValues={this.state.ShipsNameList}
                        placeholder={
                          this.state.ShipsNameList && this.state.ShipsNameList
                            ? ""
                            : "Select"
                        }
                        closeIcon="cancel"
                        value={this.state.ShipsNameList}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade p-5 mt-5"
          id="cancelpopup"
          tabindex="-1"
          role="dialog"
          aria-labelledby="cancelpopupLabel"
          aria-hidden="true"
          style={{
            top: "13%",
            left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
          }}
        >
          <div class="modal-dialog" role="document">
            <div
              class={
                this.state.isMobile ? "modal-content" : "modal-content p-3"
              }
            >
              <div class="modal-body pb-0">
                <h1 className="text-center">
                  <img src={del}></img>
                </h1>
                <div className="text-center">
                  <h5 class="fw-bold">
                  Changes are not saved yet. The data will be lost. Do you really want to cancel?
                  </h5>{" "}
                </div>
              </div>
              <div class="modal-footer border-top-0 m-auto">
                <button
                  type="button"
                  class={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  style={{ backgroundColor: "#499AC8", border: "none" }}
                  data-dismiss="modal"
                  onClick={this.AddCancel}
                >
                  <span className="">Yes</span>
                </button>
                <button
                  type="button"
                  id="closemodal1"
                  class={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  onClick={() => window.$("#cancelpopup").modal("hide")}
                  style={{
                    backgroundColor: "#EBEBEB",
                    border: "none",
                    color: "#111010",
                  }}
                >
                  <span className="">No</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade p-5 mt-5"
          id="cancelpopup1"
          tabindex="-1"
          role="dialog"
          aria-labelledby="cancelpopupLabel"
          aria-hidden="true"
          style={{
            top: "13%",
            left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
          }}
        >
          <div class="modal-dialog" role="document">
            <div
              class={
                this.state.isMobile ? "modal-content" : "modal-content p-3"
              }
            >
              <div class="modal-body pb-0">
                <h1 className="text-center">
                  <img src={del}></img>
                </h1>
                <div className="text-center">
                  <h5 class="fw-bold">
                  Changes are not saved yet. The data will be lost. Do you really want to cancel?
                  </h5>{" "}
                </div>
              </div>
              <div class="modal-footer border-top-0 m-auto">
                <button
                  type="button"
                  class={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  data-dismiss="modal"
                  style={{ backgroundColor: "#499AC8", border: "none" }}
                  onClick={this.SideBarCancel}
                >
                  <span className="">Yes</span>
                </button>
                <button
                  type="button"
                  id="closemodal1"
                  class={
                    this.state.isMobile
                      ? "btn btn-secondary"
                      : " btn btn-secondary py-2 px-4"
                  }
                  onClick={() => window.$("#cancelpopup1").modal("hide")}
                  style={{
                    backgroundColor: "#EBEBEB",
                    border: "none",
                    color: "#111010",
                  }}
                >
                  <span className="">No</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(AddEditExternalClientShips))
);
